import axiosInstance from '../../../core/api/axios';
import {
  LivesDto,
  PastLivesDto,
  PastLivesFiltersDto,
} from '../models/LivesDto.model';

export async function fetchLives(
  startDate: string,
  endDate: string
): Promise<LivesDto[]> {
  try {
    const response = await axiosInstance.get(`/lives/${startDate}/${endDate}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function fetchPastLives(
  filters: PastLivesFiltersDto,
  pageParam?: number
): Promise<PastLivesDto> {
  try {
    const {
      page = pageParam,
      limit,
      area,
      favorite,
      class: classFilter,
      review,
      monitory,
    } = filters;

    const response = await axiosInstance.get(`/lives/pastlives`, {
      params: {
        page,
        limit,
        area,
        favorite,
        class: classFilter,
        review,
        monitory,
      },
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function favoriteLive(targetId: string) {
  try {
    const response = await axiosInstance.post(`/favorites`, {
      targetId: targetId,
      targetType: 'Live',
      category: 'live',
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function fetchLiveBySlug(slug: string) {
  try {
    const response = await axiosInstance.get(`/lives/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function likeLive(slug: string, userId: string) {
  try {
    const response = await axiosInstance.get(`/lives/${slug}/like/${userId}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function dislikeLive(slug: string, userId: string) {
  try {
    const response = await axiosInstance.get(
      `/lives/${slug}/dislike/${userId}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
